export default function Privacy() {
  return (
    <div className="py-12">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white dark:text-pure-white mb-8">
          moldClaw 개인정보 처리방침
        </h1>

        <div className="prose prose-gray dark:prose-invert max-w-none">
          <p className="text-gray-500 dark:text-gray-400 mb-8">시행일: 서비스 오픈일</p>

          <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400 mb-8">
            주식회사 스페이스바(이하 "회사")는 moldClaw 서비스(이하 "서비스") 이용자의 개인정보를 중요시하며, 
            「개인정보보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법령을 준수하고 있습니다.
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              1. 수집하는 개인정보 항목
            </h2>
            
            <h3 className="text-lg font-medium text-gray-900 dark:text-white dark:text-pure-white mb-3">필수 수집 항목</h3>
            <div className="bg-gray-100 dark:bg-zinc-800 dark:bg-zinc-800 rounded-lg p-4 mb-4">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <th className="py-2 text-left font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400">항목</th>
                    <th className="py-2 text-left font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400">수집 목적</th>
                  </tr>
                </thead>
                <tbody className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2">이메일 주소</td>
                    <td className="py-2">회원 식별, 로그인, 이메일 인증, 공지사항 전달</td>
                  </tr>
                  <tr>
                    <td className="py-2">비밀번호</td>
                    <td className="py-2">회원 인증 (암호화 저장)</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className="text-lg font-medium text-gray-900 dark:text-white dark:text-pure-white mb-3">자동 수집 항목</h3>
            <div className="bg-gray-100 dark:bg-zinc-800 dark:bg-zinc-800 rounded-lg p-4">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <th className="py-2 text-left font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400">항목</th>
                    <th className="py-2 text-left font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400">수집 목적</th>
                  </tr>
                </thead>
                <tbody className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2">접속 IP 주소</td>
                    <td className="py-2">부정 이용 방지, 서비스 안정성 확보</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2">접속 일시</td>
                    <td className="py-2">서비스 이용 기록</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2">기기 정보</td>
                    <td className="py-2">서비스 최적화</td>
                  </tr>
                  <tr>
                    <td className="py-2">쿠키</td>
                    <td className="py-2">로그인 상태 유지, 사용자 설정 저장</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              2. 개인정보 수집 및 이용 목적
            </h2>
            <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-2">
              <li><strong>회원 관리</strong>: 본인 확인, 회원 식별, 부정 이용 방지</li>
              <li><strong>서비스 제공</strong>: moldClaw 앱 연동, API 키 관리, 구독 서비스 제공</li>
              <li><strong>고객 지원</strong>: 문의사항 처리, 공지사항 전달</li>
              <li><strong>서비스 개선</strong>: 이용 통계 분석, 신규 서비스 개발</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              3. 개인정보 보유 및 이용 기간
            </h2>
            <div className="bg-gray-100 dark:bg-zinc-800 dark:bg-zinc-800 rounded-lg p-4">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <th className="py-2 text-left font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400">보존 항목</th>
                    <th className="py-2 text-left font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400">보존 기간</th>
                    <th className="py-2 text-left font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400">근거 법령</th>
                  </tr>
                </thead>
                <tbody className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2">회원 정보</td>
                    <td className="py-2">탈퇴 시 즉시 파기</td>
                    <td className="py-2">개인정보보호법</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2">계약/청약철회 기록</td>
                    <td className="py-2">5년</td>
                    <td className="py-2">전자상거래법</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2">대금결제 기록</td>
                    <td className="py-2">5년</td>
                    <td className="py-2">전자상거래법</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2">소비자 불만/분쟁 기록</td>
                    <td className="py-2">3년</td>
                    <td className="py-2">전자상거래법</td>
                  </tr>
                  <tr>
                    <td className="py-2">접속 로그 기록</td>
                    <td className="py-2">3개월</td>
                    <td className="py-2">통신비밀보호법</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              4. 개인정보의 제3자 제공
            </h2>
            <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400 mb-4">
              회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다.
            </p>
            <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
              다만, 이용자가 사전에 동의한 경우 또는 법령의 규정에 의한 경우에는 예외로 합니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              5. 개인정보 처리 위탁
            </h2>
            <div className="bg-gray-100 dark:bg-zinc-800 dark:bg-zinc-800 rounded-lg p-4">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <th className="py-2 text-left font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400">수탁업체</th>
                    <th className="py-2 text-left font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400">위탁 업무</th>
                  </tr>
                </thead>
                <tbody className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2">Cloudflare, Inc.</td>
                    <td className="py-2">웹 호스팅, CDN, 보안</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2">Amazon Web Services, Inc.</td>
                    <td className="py-2">이메일 발송 (SES)</td>
                  </tr>
                  <tr>
                    <td className="py-2">Stripe, Inc.</td>
                    <td className="py-2">결제 처리</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              6. 개인정보의 국외 이전
            </h2>
            <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
              <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400 text-sm">
                회사는 서비스 제공을 위해 이용자의 개인정보를 미국에 위치한 서버(Cloudflare, AWS, Stripe)에 저장합니다. 
                <strong>이용자는 개인정보의 국외 이전에 대해 동의를 거부할 권리가 있습니다.</strong> 
                다만, 동의를 거부할 경우 서비스 이용이 제한될 수 있습니다.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              7. 이용자의 권리와 행사 방법
            </h2>
            <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400 mb-4">이용자는 언제든지 다음의 권리를 행사할 수 있습니다:</p>
            <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-1 mb-4">
              <li>개인정보 열람 요청</li>
              <li>개인정보 정정 요청</li>
              <li>개인정보 삭제 요청</li>
              <li>개인정보 처리 정지 요청</li>
              <li>동의 철회</li>
            </ul>
            <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
              <strong>행사 방법</strong>: 웹사이트 설정 또는 privacy@moldclaw.com으로 요청<br />
              <strong>처리 기한</strong>: 요청 접수일로부터 <strong>10일 이내</strong>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              8. 개인정보 보호를 위한 대책
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-gray-100 dark:bg-zinc-800 dark:bg-zinc-800 rounded-lg p-4">
                <h4 className="font-medium text-gray-900 dark:text-white dark:text-pure-white mb-2">기술적 대책</h4>
                <ul className="text-sm text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-1">
                  <li>• 비밀번호 암호화 저장</li>
                  <li>• SSL/TLS 암호화 전송</li>
                  <li>• 방화벽 및 침입탐지시스템</li>
                  <li>• 정기 보안 점검</li>
                </ul>
              </div>
              <div className="bg-gray-100 dark:bg-zinc-800 dark:bg-zinc-800 rounded-lg p-4">
                <h4 className="font-medium text-gray-900 dark:text-white dark:text-pure-white mb-2">관리적 대책</h4>
                <ul className="text-sm text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-1">
                  <li>• 취급 직원 최소화</li>
                  <li>• 정기 보안 교육</li>
                  <li>• 접근 기록 관리</li>
                  <li>• 내부 관리 계획 수립</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              9. 쿠키(Cookie)의 사용
            </h2>
            <div className="bg-gray-100 dark:bg-zinc-800 dark:bg-zinc-800 rounded-lg p-4 mb-4">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <th className="py-2 text-left font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400">쿠키 유형</th>
                    <th className="py-2 text-left font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400">목적</th>
                    <th className="py-2 text-left font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400">보관 기간</th>
                  </tr>
                </thead>
                <tbody className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2">필수 쿠키</td>
                    <td className="py-2">로그인, 보안</td>
                    <td className="py-2">세션 종료 시</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2">기능 쿠키</td>
                    <td className="py-2">사용자 설정</td>
                    <td className="py-2">1년</td>
                  </tr>
                  <tr>
                    <td className="py-2">분석 쿠키</td>
                    <td className="py-2">서비스 개선</td>
                    <td className="py-2">1년</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-sm text-gray-700 dark:text-gray-300 dark:text-zinc-400">
              브라우저 설정에서 쿠키 저장을 거부할 수 있습니다. 단, 일부 서비스 이용에 제한이 있을 수 있습니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              10. 개인정보 보호책임자
            </h2>
            <div className="bg-gray-100 dark:bg-zinc-800 dark:bg-zinc-800 rounded-lg p-4">
              <table className="w-full text-sm">
                <tbody className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2 font-medium w-1/3">회사명</td>
                    <td className="py-2">주식회사 스페이스바 (SPACEBAR Corp.)</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2 font-medium">대표자</td>
                    <td className="py-2">김정우</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2 font-medium">개인정보보호책임자</td>
                    <td className="py-2">문상혁</td>
                  </tr>
                  <tr>
                    <td className="py-2 font-medium">이메일</td>
                    <td className="py-2">privacy@moldclaw.com</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              11. 개인정보 침해 구제
            </h2>
            <div className="bg-gray-100 dark:bg-zinc-800 dark:bg-zinc-800 rounded-lg p-4">
              <p className="text-sm font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400 mb-2">문의 기관:</p>
              <ul className="text-sm text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-1">
                <li>• 개인정보침해신고센터 (KISA): 118 / privacy.kisa.or.kr</li>
                <li>• 개인정보분쟁조정위원회: 1833-6972 / www.kopico.go.kr</li>
                <li>• 대검찰청 사이버수사과: 1301 / www.spo.go.kr</li>
                <li>• 경찰청 사이버안전국: 182 / cyberbureau.police.go.kr</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              12. 고지의 의무
            </h2>
            <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
              이 개인정보 처리방침은 법령, 정책 또는 보안 기술의 변경에 따라 내용이 변경될 수 있습니다.
              변경 시에는 시행일 최소 <strong>7일 전</strong>에 공지합니다. 
              이용자의 권리에 중요한 변경이 있는 경우에는 <strong>30일 전</strong>에 고지합니다.
            </p>
          </section>

          <div className="border-t border-border-gray dark:border-zinc-700 pt-8 mt-8">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              <strong>주식회사 스페이스바 (SPACEBAR Corp.)</strong><br />
              서비스명: moldClaw<br />
              주소: 서울특별시 구로구 디지털로34길 43, 405호내 4229호<br />
              사업자등록번호: 362-86-01764<br />
              일반 문의: support@moldclaw.com<br />
              개인정보 관련: privacy@moldclaw.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
